// 大きさの換算（段階 C の2 の 7g、2026-10-26。前は d3 v4.10.2 の d3.scaleLinear。d3-scale, Copyright 2010-2017 Mike Bostock, BSD-3-Clause と同じ計算）。
// エンジンの chibi.scMake・scCategory などの x・y（元の絵の大きさ → 画面の大きさ）。計算の順番も前と同じ（端数まで同じ値になるように）
import { interpolate } from './interpolate.js';

export interface LinearScale {
  (x: number | string): number;
  domain(): number[];
  domain(d: ArrayLike<unknown>): LinearScale;
  range(): unknown[];
  range(r: ArrayLike<unknown>): LinearScale;
}

// (x - a) / (b - a)（a と b が同じなら 0）
function deinterpolate(a: number, b: number): (x: number) => number {
  const d = b - a;
  return d ? (x) => (x - a) / d : () => d;
}

/** d3.scaleLinear（既定は [0, 1] → [0, 1]。domain・range は 2 つの値） */
export function scaleLinear(): LinearScale {
  let domain: number[] = [0, 1], range: unknown[] = [0, 1];
  let output: ((x: number) => number) | null = null;
  const rescale = (): LinearScale => {
    output = null;
    return scale;
  };
  const scale = ((x: number | string): number => {
    if (!output) {
      const [d0, d1] = domain;
      const [r0, r1] = range;
      let d: (x: number) => number, r: (t: number) => unknown;
      if (d1 < d0) (d = deinterpolate(d1, d0)), (r = interpolate(r1, r0));
      else (d = deinterpolate(d0, d1)), (r = interpolate(r0, r1));
      output = (v: number) => r(d(v)) as number;
    }
    return output(+x);
  }) as LinearScale;
  scale.domain = ((d?: ArrayLike<unknown>) => {
    if (d === undefined) return domain.slice();
    domain = Array.prototype.map.call(d, Number) as number[];
    return rescale();
  }) as LinearScale['domain'];
  scale.range = ((r?: ArrayLike<unknown>) => {
    if (r === undefined) return range.slice();
    range = Array.prototype.slice.call(r);
    return rescale();
  }) as LinearScale['range'];
  return scale;
}
